import {Commission, Contractor, Dealings, Demand, Espd, Guarantee, Notice, PreparingPapersGenerator, Publication, Schedule, Siwz, NationalNotice, ExPostGoToFinish,
DemandAdditionalInfo, Questionnaire, Approval} from './panels';
import DealingsService from "services/DealingsService";
import ScheduleService from "services/ScheduleService";
import CommissionService from "services/CommissionService";
import EspdService from "services/EspdService";
import GuaranteeService from "services/GuaranteeService";
import SiwzService from "services/SiwzService";
import ContractorService from "services/ContractorService";
import NoticeService from "services/NoticeService";
import NationalNoticeService from "services/NationalNoticeService";
import DemandAdditionalInfoService from "services/DemandAdditionalInfoService";
import {DemandValidation} from "constants/DemandValidation";
import DemandApprovalService from "services/DemandApprovalService";

export default {
    mp_1_demand: Demand,
    mp_1_dealings: Dealings,
    mp_1_schedule: Schedule,
    mp_1_commission: Commission,
    mp_1_espd: Espd,
    mp_1_siwz: Siwz,
    mp_1_guarantee: Guarantee,
    mp_1_contractor: Contractor,
    mp_1_notice: Notice,
    mp_1_national_notice: NationalNotice,
    mp_1_approval: Approval,
    mp_1_publication: Publication,
    mp_1_ex_post_go_to_finish: ExPostGoToFinish,
    mp_1_preparing_papers_generator: PreparingPapersGenerator,
    mp_1_preparing_additional_info: DemandAdditionalInfo,
    mp_1_questionnaire: Questionnaire
}

export const panelsValidationKeys = {
    mp_1_demand: (id) => null,
    mp_1_dealings: (id) => DealingsService.validate(id),
    mp_1_schedule: (id) => ScheduleService.validate(id),
    mp_1_commission: (id) => CommissionService.validate(id),
    mp_1_espd: (id) => EspdService.validate(id),
    mp_1_siwz: (id) => SiwzService.validateSIWZ(id),
    mp_1_guarantee: (id) => GuaranteeService.validate(id),
    mp_1_contractor: (id) => ContractorService.validate(id),
    mp_1_notice: (id) => NoticeService.validate(id),
    mp_1_national_notice: (id) => NationalNoticeService.validate(id),
    mp_1_approval: (id) => DemandApprovalService.validate(id),
    mp_1_publication: (id) => null,
    mp_1_ex_post_go_to_finish: (id) => null,
    mp_1_preparing_papers_generator: (id) => null,
    mp_1_preparing_additional_info: (id) => DemandAdditionalInfoService.validate(id, DemandValidation.PREPARING_ADDITIONAL_INFO),
    mp_1_questionnaire: (id) => null,
}


export const isInitialHidden = (step, procedureType, passive, exPost) => {
    if(!procedureType || !step)
        return false;

    const func = hidden[step.key];
    return func && func(procedureType, passive, exPost);
}

const hidden = {
    mp_1_dealings: (procedureType, passive, exPost) => {
        return passive === 'true' || exPost === 'true';
    },
    mp_1_notice: (procedureType, passive, exPost) => {
        return "true" === passive || exPost === 'true' || ["europePublic", "europeSocialServices"].indexOf(procedureType) === -1
    },
    mp_1_guarantee: (procedureType, passive, exPost) => {
        return "true" === passive || exPost === 'true' || ["europePublic", "europeSocialServices", "nationalPublic", "nationalSocialServices"].indexOf(procedureType) === -1
    },
    mp_1_espd: (procedureType, passive, exPost) => {
        return exPost === 'true' || !procedureType.startsWith("europe")
    },
    mp_1_contractor: (procedureType, passive, exPost) => {
        return exPost === 'true';
    },
    mp_1_schedule: (procedureType, passive, exPost) => {
        return exPost === 'true';
    },
    mp_1_publication: (procedureType, passive, exPost) => {
        return exPost === 'true';
    },
    mp_1_ex_post_go_to_finish: (procedureType, passive, exPost) => {
        return exPost !== 'true';
    },
    mp_1_questionnaire: (procedureType, passive, exPost) => {
        return exPost === 'true';
    },
}

